import { render, staticRenderFns } from "./processAccidentPop.vue?vue&type=template&id=67591634"
import script from "./processAccidentPop.vue?vue&type=script&lang=js"
export * from "./processAccidentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67591634')) {
      api.createRecord('67591634', component.options)
    } else {
      api.reload('67591634', component.options)
    }
    module.hot.accept("./processAccidentPop.vue?vue&type=template&id=67591634", function () {
      api.rerender('67591634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentPop.vue"
export default component.exports